import React, { FC } from 'react'
import DocumentsContainer from 'containers/NewClient/Documents'

const ClientDocumentsPage: FC = () => <DocumentsContainer />

export default ClientDocumentsPage
